export const PhoneIcon = ({className}) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_3307_16861)">
        <path
          d="M13.1477 11.9208C13.2342 11.8632 13.3338 11.8281 13.4373 11.8187C13.5409 11.8093 13.6451 11.8258 13.7406 11.8669L17.425 13.5176C17.5492 13.5707 17.6528 13.6626 17.7204 13.7795C17.788 13.8964 17.8159 14.032 17.8 14.1661C17.6786 15.0732 17.2319 15.9053 16.543 16.5077C15.8541 17.1101 14.9698 17.4418 14.0547 17.4411C11.2368 17.4411 8.53425 16.3217 6.54168 14.3291C4.54911 12.3365 3.42969 9.63401 3.42969 6.81608C3.42899 5.90093 3.76069 5.01667 4.3631 4.32775C4.9655 3.63883 5.79762 3.19215 6.70469 3.07077C6.83878 3.05484 6.97442 3.08277 7.09131 3.15037C7.2082 3.21797 7.30006 3.32161 7.35313 3.44577L9.00391 7.13327C9.04447 7.22798 9.06098 7.33125 9.05199 7.43389C9.04299 7.53652 9.00876 7.63534 8.95235 7.72155L7.28281 9.70671C7.22359 9.79607 7.18857 9.89927 7.18118 10.0062C7.17378 10.1132 7.19427 10.2202 7.24063 10.3169C7.88672 11.6395 9.25391 12.9903 10.5805 13.6301C10.6776 13.6763 10.7852 13.6963 10.8924 13.6882C10.9997 13.6802 11.103 13.6443 11.1922 13.5841L13.1477 11.9208Z"
          stroke="#070707"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3307_16861">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.304688 0.566406)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
